export const mapStatus = {
  "Sin Pagar": "ready",
  Pagado: "paid",
  Archivado: "cancelled",
} as const;

export const mapPaymentMethod = {
  PSE: "pse",
  Nequi: "nequiButton",
  Bancolombia: "bancolombiaButton",
  Tarjeta: "card",
  BreB: "breb",
} as const;

export const mapPaymentSource = {
  Portal: "portal",
  Whatsapp: "whatsapp",
} as const;

export const mapCreationMethod = {
  Manual: "manual",
  Archivo: "bulk",
  ERP: "erp",
} as const;

export const mapErpSyncStatus = {
  Automática: "success", // Contabilizado
  "Reintento Exitoso": "retry", // Contabilizado en Reintento
  Manual: "manual", // Contabilización Manual
  Pendiente: "off_hours", // Esperando Horario Laboral
  "En Proceso": "processing", // Contabilización en Procesamiento
  "Con Error": "error", // Con Error
  "Sin Contabilizar": "none", // Sin Contabilización
} as const;

export const mapCancelationReason = {
  expired: "Expirado",
  manual: "Manual",
  oneInvoicePerContract: "Una factura por contrato",
  erp: "ERP",
  declined: "Declinado",
} as const;
